import { TooltipWrapper } from '@components/TooltipWrapper';
import { CloudDownloadIcon, FileIcon } from 'lucide-react';
import { formatDate, formatFileSize, getFormatLabel } from './helpers';
import type { PublicationDocumentItemProps } from './types';

const PublicationDocumentItem: React.FC<PublicationDocumentItemProps> = ({ document, language, variousFundsText }) => {
  const { docTypeName, fundName, fileDate, mimeType, size, url, fileName } = document;

  const cleanFormat = getFormatLabel(mimeType);

  // Build pipe-separated metadata line (matching ArchiveFileLink's subData.join(' | ') pattern)
  const subData: string[] = [];
  const formattedDate = formatDate(fileDate, language);
  if (formattedDate && formattedDate !== '—') {
    subData.push(formattedDate);
  }
  if (cleanFormat && cleanFormat !== '—') {
    subData.push(cleanFormat);
  }
  const formattedSize = formatFileSize(size);
  if (formattedSize) {
    subData.push(formattedSize);
  }

  const downloadUrl = url || fileName || null;
  const hasLink = downloadUrl !== null;

  const contentElement = (
    <div className="min-w-0 flex-1">
      <h4 className="mb-[5px] text-[13px] uppercase tracking-[0.5px] text-accent">{`${docTypeName}: ${fundName && fundName.length <= 2 ? fundName.filter(Boolean).join(', ') : variousFundsText || 'Various Funds'}`}</h4>
      <div className="text-xs leading-normal text-black">{`${subData.join(' | ')}`}</div>
    </div>
  );

  if (!hasLink) {
    return (
      <div className="relative flex items-center justify-start border-b border-[#f2f2f2] py-5 pr-5 last:border-b-0">
        <span className="mr-[5px] inline-block w-[60px] min-w-[60px]">
          <FileIcon className="text-gray-400" strokeWidth={1} />
        </span>
        {contentElement}
      </div>
    );
  }

  return (
    <a
      href={downloadUrl}
      className="relative flex items-center cursor-pointer gap-3 justify-start border-b border-[#f2f2f2] py-5 pr-5 no-underline last:border-b-0"
      download={downloadUrl}
      target="_blank"
      rel="noreferrer"
    >
      <span className="mr-[5px] inline-block w-[60px] min-w-[60px]">
        <FileIcon className="text-gray-400" strokeWidth={1} />
      </span>
      {contentElement}
      <TooltipWrapper text="Download">
        <CloudDownloadIcon className="text-gray-400 pointer-events-none inline" />
      </TooltipWrapper>
    </a>
  );
};

export { PublicationDocumentItem };
